import {
  type GetStaticPaths,
  type GetStaticProps,
  type NextPageWithLayout,
} from 'next'
import React, { type ReactNode } from 'react'
import { getPublicLayout } from '@public/components/PublicLayout'
import { ROUTE } from 'constants/routes'
import { CmsConsultationPageSlugsDocument } from 'types/graphql-generated'
import { initializeApollo } from 'utils/apolloClient'
import { ConsultationsPageView } from './ConsultationsPageView'
import { useCmsConsultationPageBySlug } from './hooks/useCMSConsultationPageBySlug'
import { prepareGetStaticPropsForConsultationsPage } from './prepareGetStaticPropsForConsultationsPage'

interface ConsultationsPageProps {
  slug: string
  isPreview?: boolean
}

export const ConsultationsPage: NextPageWithLayout<ConsultationsPageProps> = ({
  slug,
  isPreview,
}) => {
  const { pageBySlug, isLoading, widgets } = useCmsConsultationPageBySlug({
    slug,
    isPreview,
  })

  return (
    <ConsultationsPageView
      isPreview={isPreview}
      slug={slug}
      data={pageBySlug}
      isLoading={isLoading}
      widgets={widgets}
      isSearchFilterParamsMode
    />
  )
}

export const getStaticPaths: GetStaticPaths = async () => {
  const apolloClient = initializeApollo()
  const { data } = await apolloClient.query({
    query: CmsConsultationPageSlugsDocument,
  })
  const paths =
    data?.cmsConsultationPageSlugs?.map((slug: string) => ({
      params: { slug },
    })) || []

  return {
    paths,
    fallback: 'blocking',
  }
}

export const getStaticProps: GetStaticProps = (context) => {
  const slug = `consultations/${context.params?.slug}`
  const route = ROUTE.CONSULTATIONS_DYNAMIC({
    slug: context.params?.slug as string,
  })

  return prepareGetStaticPropsForConsultationsPage(context, { slug, route })
}

const PageLayout = (page: ReactNode) =>
  getPublicLayout(page, { isFullWidth: true, isWithBreadcrumbs: true })

ConsultationsPage.getLayout = PageLayout
